/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppointAnIntermediaryViewModel } from './AppointAnIntermediaryViewModel';
import {
    AppointAnIntermediaryViewModelFromJSON,
    AppointAnIntermediaryViewModelFromJSONTyped,
    AppointAnIntermediaryViewModelToJSON,
} from './AppointAnIntermediaryViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfAppointAnIntermediaryViewModel
 */
export interface ResultOfAppointAnIntermediaryViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfAppointAnIntermediaryViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAppointAnIntermediaryViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfAppointAnIntermediaryViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAppointAnIntermediaryViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAppointAnIntermediaryViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfAppointAnIntermediaryViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfAppointAnIntermediaryViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {AppointAnIntermediaryViewModel}
     * @memberof ResultOfAppointAnIntermediaryViewModel
     */
    data?: AppointAnIntermediaryViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfAppointAnIntermediaryViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfAppointAnIntermediaryViewModel interface.
 */
export function instanceOfResultOfAppointAnIntermediaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfAppointAnIntermediaryViewModelFromJSON(json: any): ResultOfAppointAnIntermediaryViewModel {
    return ResultOfAppointAnIntermediaryViewModelFromJSONTyped(json, false);
}

export function ResultOfAppointAnIntermediaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfAppointAnIntermediaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : AppointAnIntermediaryViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfAppointAnIntermediaryViewModelToJSON(value?: ResultOfAppointAnIntermediaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': AppointAnIntermediaryViewModelToJSON(value.data),
        'Count': value.count,
    };
}

